import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing16,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { fontWeightBold } from 'approot/shared/styles/typography.style';
import { grey10, grey2 } from 'approot/shared/styles/colours.style';
import {
  RichtextProps,
  richtextCommonCss,
} from 'approot/shared/richtext/richtext.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';

export const SubActivity = styled.div`
  color: ${grey10};
`;

export const SubActivityLabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

type SubActivityLabelProps = {
  $isZoomed?: boolean;
};
export const SubActivityLabel = styled.span<SubActivityLabelProps>`
  ${({ $isZoomed }) =>
    useActivityBuilderFontStyles({
      isSmall: true,
      isZoomed: $isZoomed,
    })}

  display: inline-block;
  font-weight: ${fontWeightBold};
  margin-right: ${rem(spacing4)};
  margin-bottom: ${rem(spacing16)};
`;

export const SubActivityInstruction = styled.div.attrs<RichtextProps>({
  $isSmall: true,
})`
  display: inline-block;
  margin-bottom: ${rem(spacing8)};
  ${richtextCommonCss}
  width: 100%;
`;

export const SubActivityButton = styled.button`
  background: transparent;
  border-radius: ${rem(borderRadius8)};
  border: none;
  margin-bottom: ${rem(spacing8)};
  padding: 0;
  width: 100%;
  text-align: left;

  ${SubActivityLabel}, ${SubActivityInstruction} {
    margin-bottom: 0;
  }

  &:hover {
    background-color: ${grey2};
    cursor: pointer;
  }

  ${standardFocusState}
`;
